<template>
    <div>
        <!-- Header -->
        <div class="pt-3 pb-1 mb-3 bg-white border-bottom">
            <div class="container">
                <div class=" d-flex align-content-center justify-content-between align-items-center">
                    <div>
                        <a href="/student/essays/all">
                            <i class="fas fa-arrow-left mr-1"></i> Voltar a todas as redações
                        </a>
                    </div>
                </div>

                <b-alert v-if="essay.status !== 'OKAY'" :show="true" variant="danger">
                    A redação ainda está aguardando correção ...
                </b-alert>

                <div class="d-none d-sm-block row py-2">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="lh-md d-flex flex-column">
                            <div class="fw-medium  fs-6">
                                <span v-if="essay.student ">
                                    Aluno: {{ essay.student.name }}
                                </span>
                                <span v-if="essay.group">
                                    &#8226; {{ essay.group.name }}
                                </span>
                            </div>
                            <div class="text-black-50 fw-normal ">
                                Professor/Corretor:
                                <span v-if="essay.teacher" class="fw-bolder">
                                    {{ essay.teacher.name }}
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </div>
                            <div class="text-black-50 fw-normal ">
                                Tema:
                                <span v-if="essay.theme">
                                    <a :href="'/teacher/themes/' + essay.theme.id" target="_blank">
                                        {{ essay.theme.title | truncate(30) }}
                                    </a>
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </div>
                            <div class="text-black-50 fw-normal" >
                                <span v-if="essay.mode">
                                    Modo: {{ essay.mode.name }}
                                </span>
                                <span v-else-if="essay.theme">
                                    Modo: {{ essay.theme.mode.name  }}
                                </span>
                                <span v-else>
                                    Modo: ---
                                </span>
                            </div>
                        </div>

                        <div class="d-flex gap-3 align-items-top lh-md">
                            <div class="d-flex flex-column justify-content-end  text-end">
                                <div class="">

                                    <span v-if="essay.status === 'BLOCK'" class="px-2 py-1 rounded-pill text-warning" style="background-color: #ffc10720;">
                                        Aguardando Devolução
                                    </span>

                                    <span v-if="essay.status === 'WAIT'" class="px-2 py-1 rounded-pill text-danger" style="background-color: #dc354520;">
                                        Aguardando
                                    </span>

                                    <span v-if="essay.status === 'IN_PROGRESS'" class="px-2 py-1 rounded-pill text-info" style="background-color: #0dcaf020;">
                                        Em Andamento
                                    </span>

                                    <span v-if="essay.status === 'OKAY'" class="w-auto px-2 py-1 rounded-pill text-success" style="background-color: #19875420;">
                                        Corrigida
                                    </span>

                                </div>
                                <div class="text-black-50 fw-normal">
                                    Última atualização: {{ essay.updated_at | moment('from', 'now') }}
                                </div>
                                <div class="text-black-50 fw-normal">
                                    Enviada: {{ essay.created_at | moment('from', 'now') }}
                                </div>
                                <div class="text-black-50 fw-normal p-0" v-if="essay.status === 'OKAY'">

                                    <b-form-rating v-model="rating" color="#ff8800" no-border inline show-value show-value-max></b-form-rating>
                                </div>
                            </div>
                            <div class="gap-2" >
                                <div>
                                    <a :href="'/student/essays/' + essay.id + '/export'" v-if="essay.status === 'OKAY'" class="btn-outline-primary btn d-flex align-items-center gap-2 " role="button" target="_blank">
                                        <svg class="icons-lg"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                          </svg>
                                        Baixar PDF
                                    </a>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>

                <!--mobile-->
                <div class="d-block d-sm-none row py-2 mt-2">
                    <div class="d-flex justify-content-between gap-3 align-items-center lh-md">
                        <div class="d-flex flex-column justify-content-between text-end">
                            <div class="">
                                <span v-if="essay.status === 'BLOCK'" class="px-2 py-1 rounded-pill text-warning" style="background-color: #ffc10720;">
                                    Aguardando Devolução
                                </span>

                                <span v-if="essay.status === 'WAIT'" class="px-2 py-1 rounded-pill text-danger" style="background-color: #dc354520;">
                                    Aguardando
                                </span>

                                <span v-if="essay.status === 'IN_PROGRESS'" class="px-2 py-1 rounded-pill text-info" style="background-color: #0dcaf020;">
                                    Em Andamento
                                </span>

                                <span v-if="essay.status === 'OKAY'" class="w-auto px-2 py-1 rounded-pill text-success" style="background-color: #19875420;">
                                    Corrigida
                                </span>

                            </div>

                        </div>
                        <div class="text-black-50 fw-normal p-0" v-if="essay.status === 'OKAY'">

                            <b-form-rating v-model="rating" color="#ff8800" no-border inline show-value show-value-max></b-form-rating>
                        </div>
                    </div>
                    <div class="lh-sm d-flex flex-column mt-2">
                        <div class="fw-medium  fs-6">
                            <span v-if="essay.student ">
                                Aluno: {{ essay.student.name }}
                            </span>
                            <span v-if="essay.group">
                                &#8226; {{ essay.group.name }}
                            </span>
                        </div>
                        <div class="text-black-50 fw-normal ">
                            Professor/Corretor:
                            <span v-if="essay.teacher" class="fw-bolder">
                                {{ essay.teacher.name }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </div>

                        <div class="text-black-50 fw-normal ">
                            Tema:
                            <span v-if="essay.theme">
                                <a :href="'/teacher/themes/' + essay.theme.id" target="_blank">
                                    {{ essay.theme.title | truncate(30) }}
                                </a>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </div>
                        <div class="text-black-50 fw-normal" >
                            <span v-if="essay.mode">
                                Modo: {{ essay.mode.name }}
                            </span>
                            <span v-else-if="essay.theme">
                                Modo: {{ essay.theme.mode.name  }}
                            </span>
                            <span v-else>
                                Modo: ---
                            </span>
                        </div>

                    </div>
                    <div class="w-100 border-top mt-2 pt-2 mx-2"></div>
                    <div class="lh-sm text-black-50 fw-normal">
                        Última atualização: {{ essay.updated_at | moment('from', 'now') }}
                    </div>
                    <div class="lh-sm text-black-50 fw-normal">
                        Enviada: {{ essay.created_at | moment('from', 'now') }}
                    </div>
                    <div class="gap-2 mt-2" >
                        <div>
                            <a :href="'/student/essays/' + essay.id + '/export'" v-if="essay.status === 'OKAY'" class="btn-outline-primary btn d-flex align-items-center gap-2 " role="button" target="_blank">
                                <svg class="icons-lg"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                </svg>
                                Baixar PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Block Essay -->
        <div class="container" v-if="essay.status === 'BLOCK'">
            <b-alert variant="danger" dismissible show>
                Você precisa reenviar a imagem dessa redação. Verifique seu email para acessar o link de reenvio.
            </b-alert>
        </div>

        <!-- Notes -->
        <div class="container" v-if="essay.status === 'OKAY' && !essay.no_note">
            <div class="row">
                <note :essay-id="essay.id"></note>
            </div>
        </div>

        <!-- Content -->
        <div class="container" v-if="essay.status === 'OKAY'">
            <div class="row">
                <div class="col-sm-9">

                    <!-- Content Img -->
                    <div v-if="essay.new_version">

                        <content-img-new :essay="essay" v-if="essay.content_type === 'IMG'"></content-img-new>

                    </div>
                    <div v-else>

                        <content-img :essay="essay" @annotations="getAnnotations" v-if="essay.content_type === 'IMG'"></content-img>

                    </div>



                </div>
                <div class="col-sm-3">

                    <div v-if="telegram" class="mb-3">

                        <div class="h5">
                            Telegram
                            <span v-b-tooltip.hover title="Aqui você pode ir para o Telegram do seu Professor/Mentor">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icons-lg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </span>
                        </div>

                        <a :href="telegram" target="_blank" class="btn-link text-info" >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="16px" class="icons mr-1" viewBox="0 0 512 512">
                                <path d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"/>
                            </svg>
                            Ir para o Link do Telegram
                        </a>
                    </div>

                    <!-- Observations -->
                    <observations :essay="essay" :comment-full="commentFull" v-if="!commentFull"></observations>

                    <!-- Documents -->
                    <essay-documents :essay="essay"></essay-documents>

                    <!-- Áudio -->
                    <essay-audio-multiple :essay="essay"></essay-audio-multiple>



                </div>

                <div class="col-sm-12">
                    <!-- Observations -->
                    <observations :essay="essay" :comment-full="commentFull" v-if="commentFull"></observations>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContentImg from "./CorrectionComponents/ContentImg";
import ContentImgNew from "./CorrectionComponents/ContentImgNew";
import Note from './CorrectionComponents/Note';
import Observations from "./CorrectionComponents/Observations";
import EssayAudio from "./CorrectionComponents/Audio"
import EssayAudioMultiple from "./CorrectionComponents/AudioMultiple"
import EssayDocuments from './CorrectionComponents/Documents.vue';

export default {
    components: {
        ContentImg,
        ContentImgNew,
        Note,
        Observations,
        EssayAudio,
        EssayAudioMultiple,
        EssayDocuments
    },
    props: ['essay', 'commentFull', 'telegram'],
    data() {
        return {
            loading: false,
            urlPdf: null,
            annotations: [],
            rating: null,
        }
    },
    watch: {
        'rating': async function (value) {
            if(this.essay.rating === this.rating){
                return
            }
            await this.changeRating(value);
        }
    },
    created() {
        if(this.essay.content_type === "TEXT"){
            window.location.href = 'correction/new'
        }
        this.rating = this.essay.rating;
    },
    methods: {
        getAnnotations(annotations) {
            this.annotations = annotations
        },
        changeRating(value) {
            axios.put('/student/essays/' + this.essay.id + '/rating', {
                rating: value
            })
                .then((result) => {
                    const response = result.data.data;

                    // Save Message
                    this.$toast.success('Sua avaliação foi salva :)', {
                        position: 'top-right',
                        duration: 1500
                    })
                })
        }
    }
}
</script>

<style scoped>
    .icons{
        height: 16px;
    }
    .icons-lg{
        height: 20px;
    }
</style>
